import tree from '@/components/tree.vue'
import { djxc } from '@/axios'
import Page from '@/components/page.vue'
import { Message } from 'element-ui'
import DelData from '@/components/delToast.vue'
import myTables from '@/components/tables/tables.vue'
let that;
export default{
	data(){
		return{
			getdata:{
				user_id:this.$store.state.user.userinfo.id,
				flag:this.$store.state.user.userinfo.flag,
				page:1,
				year:"",
				type:"",
				title:""
			},
			tableHeader: [     // 表头
				{prop: 'img', label: '封面',width:"135"},
				{prop: 'title', label: '标题',width:""},
				{prop: 'gu_name', label: '所属党支部',width:"160"},
				{prop: 'type', label: '分类',width:"90",formatData:(val) => {
					if(val == 1){
						return '党员风采'
					}else if(val == 2){
						return '组织风采'
					}else{
						return '未知类型'
					}
				}},
				// 如果后端传过来的值不是我们所预期的，此处可以如下判断修改，isok是是否需要渲染为el-tag,效果为下图
				{prop: 'k_time', label: '发布时间'},
				// 此处为操作栏，不需要可以删除，clickFun绑定此操作按钮的事件
				{
					prop: 'oper', label: '操作', fixed: 'right', width: '160',
					oper: [
						{name: '详情', style: {color:'#bb0000'}, clickFun: this.showDetail},
						{name: '编辑', style: {color:'#bb0000'}, clickFun: this.edit},
						{name: '删除', style: {color:'#bb0000'}, clickFun: this.del},
					]
				}
			],
			delList:[],
			typeList:[],
			tableData:[],
			totalPage:0
		}
	},
	components:{tree,Page,DelData,myTables},
	created(){that = this},
	mounted() {
		that.dataList();
	},
	methods:{
		// 数据
		dataList(){
			djxc.thearList(that.getdata).then(res => {
				that.tableData = res.data.pagedata;
				that.totalPage = res.data.count;
			})
		},
		// 树形结构筛选
		treeSelect(data){
			that.getdata.user_id = data.id;
			that.getdata.flag = data.flag;
			that.getdata.page = 1;
			that.dataList();
		},
		// 新增
		addZbfc(){
			that.$router.push({
				path:'/fczs_add',
				query:{
					flag:that.getdata.flag,
					id:that.getdata.id,
					type:'add'
				}
			})
		},
		// 编辑
		edit(data){
			that.$router.push({
				path:"/fczs_add",
				query:{
					id:data.id,
					flag:data.flag,
					type:'edit',
					fctype:data.type
				}
			})
		},
		// 详情
		showDetail(data){
			that.$router.push({
				path:"/fczs_detail",
				query:{
					flag:data.flag,
					id:data.id,
					fctype:data.type
				}
			})
		},
		// 分页筛选
		changedata(current){
			that.getdata.page = current;
			that.dataList();
		},
		// 一键删除
		selectList(value){
			that.delList = [];
			that.typeList = [];
			value.forEach(item => {
				that.delList.push(item.id)
				that.typeList.push(item.type)
			})
		},
		delAll(){
			if(that.delList.length == 0){
				Message.warning('请先选择要删除得数据')
			}else{
				that.delData();
			}
		},
		//	删除操作
		delData(){
			that.$refs.delDatas.showToast(res => {
				if(res){
					djxc.delThear({
						id:that.delList,
						type:that.typeList
					}).then(res => {
						if(res.code == 200){
							Message({
								type: 'success',
								message: '删除成功!'
							})
						}else{
							Message({
								type: 'error',
								message: res.msg
							})
						}
						that.getdata.page = 1;
						that.dataList();
					})
				}
			})
		},
		// 删除
		del(data){
			that.delList = [];
			that.typeList = [];
			that.delList = [data.id];
			that.typeList = [data.type]
			that.delData();
		}
	}
}